import loadable from '../../utilities/loadable'

export default loadable(() => import('./Deals'))
